const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-soil" */ '@/pages/base-info/order-properties/soil/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-soil" */ '@/pages/base-info/order-properties/soil/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-soil" */ '@/pages/base-info/order-properties/soil/edit.vue'
  )

export default {
  path: 'soil',
  meta: {
    label: 'soil',
    auth: 'soil'
  },
  component: {
    name: 'Soil',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesSoil',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesSoil',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesSoil',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
